import React, { Component } from 'react';
import { Modal, Radio } from 'antd';
import API_URL from '../../../../common/url';
import ExportUtil from '../../../../common/ExportUtil';

const RadioGroup = Radio.Group;

class ExportModal extends Component {
    state = {
        visible: false,
    }

    show = (searchParams) => {
        this.setState({
            flag: 1,
            searchParams,
            visible: true,
        });
    }

    handleOk = () => {
        const { flag, searchParams } = this.state;

        ExportUtil.export({ flag, ...searchParams }, null, API_URL.sumtotal.exportInvestigationCrcWeek);
        this.setState({ visible: false });
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    onChange = (e) => {
        this.setState({ flag: e.target.value });
    }

    render () {
        const { visible, flag } = this.state;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
            >
                <div className="cont-cont" style={{ padding: '30px 20px' }}>
                    <ul className="preview-list">
                        <li className="preview-item">
                            <div className="item" style={{ width: '35%' }}>
                                <label className="ui-label">是否导出进展信息?</label>
                            </div>
                            <div className="item" style={{ marginLeft: 24 }}>
                                <RadioGroup onChange={this.onChange} value={flag}>
                                    <Radio value={1}>是</Radio>
                                    <Radio value={0}>否</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default ExportModal;



// WEBPACK FOOTER //
// ./src/components/sumTotal/crcWeekly/components/ExportModal.js